import Reveal from "./Reveal";
import { protocolGroups } from "@/config/professional";

export default function Protocols() {
  return (
    <section className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
              Protocolos
            </p>
            <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
              Protocolos para diferentes necessidades.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600 md:text-lg">
              Condições que podem fazer parte das avaliações e protocolos
              realizados pela profissional, sempre conforme indicação
              individual.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-10 md:grid-cols-2">
          {protocolGroups.map((group, gi) => (
            <Reveal key={group.title} delay={gi * 60}>
              <div className="border-t border-primary-600/20 pt-6">
                <h3 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                  {group.title}
                </h3>
                <ul className="mt-5 flex flex-wrap gap-2.5">
                  {group.items.map((item) => (
                    <li
                      key={item}
                      className="whitespace-nowrap rounded-full border border-secondary-300 bg-secondary-100/50 px-4 py-2 text-sm text-secondary-900"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-12 rounded-lg border border-accent-300/50 bg-accent-100/50 p-6 text-sm leading-relaxed text-foreground-700">
            <p className="font-semibold text-foreground-900">
              Importante:
            </p>
            <p className="mt-2">
              A Laserterapia é um recurso terapêutico que pode auxiliar em
              determinadas condições quando indicado. Ela não substitui o
              acompanhamento médico nem promete cura. Toda condição deve ser
              avaliada individualmente por um profissional habilitado.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}